/*
CopyRight: 2019 - ArTiBulles
Created on : 02-July-2019
Author: Arnaud Jaspard - Arnaud.jaspard@artibulles.com
Version: 1.0
Description: Creating React Icons with Frames
License : MIT
*/
import React from "react";
import createSvgIcon from './utils/createSvgIcon';
var name = "ArrowSimpleLeft";
var keywords = ["arrow", "Navigation"];
var category = "navigation";
var meta = {
  keywords: keywords,
  name: name,
  category: category,
  "class": "Icon_".concat(name)
};
export default createSvgIcon( /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  strokeLinecap: "round",
  points: "76 5 25 50 76 95"
}), meta);